export default __webpack_public_path__ + "static/media/Foto14.13864124.png";